import React from 'react'
import { PlecaGreen } from './LayoutCustomerSuccess.styles'
import Main from 'src/components/common/Main/Main'
import { WraperContainer } from 'src/components/common/grids/styles'
import { GridItem } from 'src/components/common/grids'
import { Layout } from '../layout/layout'

const LayoutCustomerSuccess = ({ children, title = null }) => {
    return (
        <>
            <Layout marginsMain={false}>
                <PlecaGreen>
                    <Main>
                        <WraperContainer>
                            <GridItem>
                                <div className="wrapperInfo">
                                    <>
                                        <h1>{title ?? "PANEL COSTUMER SUCCESS"}</h1>
                                    </>
                                </div>
                            </GridItem>
                        </WraperContainer>
                    </Main>
                </PlecaGreen>
                {children}
            </Layout>
        </>
    )
}

export default LayoutCustomerSuccess;